import { CSSProperties } from 'react';
import { css, RuleSet } from 'styled-components';

const unitlessProps = new Set([
  'opacity',
  'zIndex',
  'fontWeight',
  'lineHeight',
  'flexGrow',
  'flexShrink',
  'order',
  'zoom',
]);

const styleToCss = (style: CSSProperties): RuleSet<object> => {
  const importantStyle: Record<string, string> = {};

  Object.entries(style).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      if (typeof value === 'number') {
        const needsUnit = !unitlessProps.has(key);
        importantStyle[key] = `${value}${needsUnit ? 'px' : ''} !important`;
      } else {
        importantStyle[key] = `${value} !important`;
      }
    }
  });

  return css(importantStyle);
};

export default styleToCss;
